module.exports = __webpack_public_path__ + "static/media/seo-friendly.70633303.jpg";